// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ENTER_EMAIL_OR_USERNAME_YOU_HAVE_REGISTERED = "Zadaj email alebo login, ktor\u00fd si zadala pri registr\u00e1cii:";
export const PASSWORD_RESET_EMAIL_OR_USERNAME_INVALID = "Toto nevyzer\u00e1 ako spr\u00e1vne prihlasovacie meno alebo e-mailov\u00e1 adresa";
export const SEND = "Odo\u0161li";
export const YOU_DID_NOT_ENTER_EMAIL = "Zabudla si zada\u0165 tvoj email.";
